const HUBSPOT_SCRIPT_ID = 'hs-script-loader'

export const HUBSPOT_TRACKING_COOKIES = ['__hstc', 'hubspotutk', '__hssc', '__hssrc']

// The server only emits a script URL when the feature flag is enabled. Use that
// single browser-side signal for script loading, consent APIs, and cleanup.
export function isHubSpotTrackingConfigured() {
  return typeof window !== 'undefined' && Boolean(window.HUBSPOT_TRACKING_SCRIPT_SRC)
}

function mapOsanoToHubSpotConsent(consent) {
  // Cross-property policy: papa-site and the shared Osano configuration classify
  // portal 4038551 as Marketing, so HubSpot analytics follows that category.
  // get.papa.com already owns its Meta pixel; keep HubSpot-managed Meta and
  // LinkedIn disabled here to avoid duplicate or newly introduced ad tracking.
  const marketing = Boolean(consent.marketing)

  return {
    analytics: marketing,
    advertisement: false,
    functionality: Boolean(consent.personalization),
  }
}

export function syncHubSpotTracking(consent) {
  if (!isHubSpotTrackingConfigured()) return

  const marketingGranted = Boolean(consent.marketing)
  const hubspotConsent = mapOsanoToHubSpotConsent(consent)
  const hsp = (window._hsp = window._hsp || [])
  hsp.push(['setHubSpotConsent', hubspotConsent])

  // Do not fetch the HubSpot loader until the cross-property Marketing category
  // is granted.
  if (!marketingGranted) return

  // A previous denial may have set HubSpot's persistent DNT cookie. Queue its
  // removal before loading so the initial page view can be associated.
  const hsq = (window._hsq = window._hsq || [])
  hsq.push(['doNotTrack', { track: true }])

  // The canonical DOM id is the source of truth for idempotency and also
  // protects against a future server-side or third-party injection.
  if (document.getElementById(HUBSPOT_SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = HUBSPOT_SCRIPT_ID
  script.type = 'text/javascript'
  script.async = true
  script.defer = true
  script.src = window.HUBSPOT_TRACKING_SCRIPT_SRC
  document.head.appendChild(script)
}

export function revokeHubSpotTracking() {
  if (!isHubSpotTrackingConfigured()) return

  // revokeCookieConsent removes HubSpot-managed tracking cookies; DNT prevents
  // even anonymized collection until a later grant queues {track: true}.
  const hsp = (window._hsp = window._hsp || [])
  hsp.push(['revokeCookieConsent'])

  const hsq = (window._hsq = window._hsq || [])
  hsq.push(['doNotTrack'])
}
